import { AsyncPipe, JsonPipe, NgIf } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { CanDisable, mixinDisabled } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTableModule } from '@angular/material/legacy-table';
import { MatTable } from '@angular/material/table';
import _ from 'lodash';
import { Observable, tap } from 'rxjs';
import { ComponentsModule } from '../../../components/components.module';
import { Countertop } from '../../../models/cutting/countertop';
import { Cutout, CutoutPoint } from '../../../models/cutting/cutting-panel-outline.model';
import { Position } from '../../../models/cutting/cutting-svg.model';
import { LegacyDialogsService } from '../../../services/legacy-dialogs.service';
import { CountertopSettingsStateService } from '../countertop-settings-state.service';
import { PlateCutoutWizardDialogComponent } from '../plate-cutout-wizard-dialog/plate-cutout-wizard-dialog.component';

export class CutoutsBase {}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const _CutoutsMixinBase = mixinDisabled(CutoutsBase);

@Component({
  selector: 'csl-cutouts',
  templateUrl: 'cutouts.component.html',
  styles: [
    `
      table {
        th,
        td {
          @apply px-1;

          &:first-child {
            @apply pl-2;
          }

          &:last-child {
            @apply pr-2;
          }
        }

        .mat-column-delete {
          width: 0 !important;
        }
      }
    `,
  ],
  standalone: true,
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
  imports: [MatLegacyTableModule, ComponentsModule, MatIconModule, AsyncPipe, NgIf, JsonPipe],
})
export class CutoutsComponent extends _CutoutsMixinBase implements CanDisable {
  displayedColumns = ['x', 'y', 'height', 'width', 'radius', 'panelBasePoint', 'cutoutBasePoint', 'delete'];

  data$: Observable<any>;
  get cutouts(): Cutout[] {
    return this.countertop?.outline.cutouts ?? [];
  }
  countertop: Countertop;

  @ViewChild(MatTable) table: MatTable<Cutout>;

  thisCutoutPoint = CutoutPoint;

  constructor(
    private dialogs: LegacyDialogsService,
    private countertopSettingsService: CountertopSettingsStateService
  ) {
    super();

    this.data$ = this.countertopSettingsService.countertop$.pipe(
      tap((p: Countertop) => {
        this.countertop = p;
      })
    );
  }

  openWizard(): void {
    this.dialogs
      .component(PlateCutoutWizardDialogComponent, this.countertop, undefined, {
        minWidth: '90vw',
        width: '90vw',
        maxWidth: '90vw',
      })
      .subscribe((result: Cutout) => {
        if (result) {
          this.countertop.outline.cutouts = _.concat(this.countertop.outline.cutouts, result);
          this.countertopSettingsService.updateCountertop(this.countertop);
        }
      });
  }

  deleteCutout(item: Cutout): void {
    this.countertop.outline.cutouts = _.without(this.cutouts, item);
    this.countertopSettingsService.updateCountertop(this.countertop);
  }

  cutoutPoint2Position(cp: CutoutPoint): Position {
    switch (cp) {
      case CutoutPoint.TopLeft:
        return 'tl';
      case CutoutPoint.TopRight:
        return 'tr';
      case CutoutPoint.BottomLeft:
        return 'bl';
      case CutoutPoint.BottomRight:
        return 'br';
      case CutoutPoint.Center:
        return 'c';
    }
  }
}
